export const API_MONTH_FORMAT = 'YYYYMM';
export const API_DATE_FORMAT = 'YYYY-MM-DD';



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/consts.js